import axios from 'axios'
export default {
    data () {
        return {
            companyList: this.$route.meta.companyList
        }
    },
    methods: {
        getSourceName (code) {
            let data = this.companyList.filter(item => item.code === code)
            return data.length ? data[0].name : '-'
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/supplier/companyList.js